import { render, staticRenderFns } from "./xiaoxi.vue?vue&type=template&id=573f10b9&scoped=true"
import script from "./xiaoxi.vue?vue&type=script&lang=js"
export * from "./xiaoxi.vue?vue&type=script&lang=js"
import style0 from "./xiaoxi.vue?vue&type=style&index=0&id=573f10b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f10b9",
  null
  
)

export default component.exports